// Google map key is also placed hardcoded in public/index.html
export const GOOGLE_MAP_KEY = "AIzaSyA0eoYnn4K0ShoUxhjYKPThufrjtRckOnA";
export const GIFTCARD_CONFIG_KEY = "GiftCardConfig";
export const PROMO_GIFTCARD_CONFIG_KEY = "PromotionalGiftCardConfig";

export const MEET_PROVIDER = "Google";
